import React from 'react';
import PropTypes from 'prop-types';

import ProductReview from '../../product/components/product-review';
import IntraDayDeals from '../../product/components/deals';
import ProductPriceV2 from '../../product/components/product-price/product-price-v2';
import LazyLoadImage from '../../shared/components/lazyload-image';
import ProductCardHeader from '../../product/components/product-card-header';
import Icon from '../../ui/components/icon';
import PurchaseButton from '../../product/components/purchase-button-container';
import Link from '../../ui/components/link';

import './compare-box-detail.less';

function CompareBoxDetail({ product, toggleCompareProduct }) {
    return (
        <div className="compare-box detail v2" large={2}>
            <div className="header">
                <ProductCardHeader product={product} saleCalloutPath="violatorMsg" />
                <span className="action" onClick={() => toggleCompareProduct(product)}>
                    <Icon name="x" size={16} />
                </span>
            </div>

            <LazyLoadImage height={200} once offset={400} src={product.imageUrl} />
            <ProductReview product={product} displayAvgRating className={'v2'} />
            <IntraDayDeals itemId={product.itemId}>
                {dealProps => {
                    const { isActive, productDeals } = dealProps;
                    const deal = isActive ? productDeals.activeDeal : null;
                    return <ProductPriceV2 product={product} deal={deal} displayDifference />;
                }}
            </IntraDayDeals>
            <Link to={product.linkUrl} target>
                See more
            </Link>
            <PurchaseButton product={product} isV2 />
        </div>
    );
}

CompareBoxDetail.propsTypes = {
    /** product object */
    product: PropTypes.object,
    /** add/remove product from compare set */
    toggleCompareProduct: PropTypes.func,
};

export default CompareBoxDetail;
